<script lang="ts" setup>
//
</script>

<template>
  <div class="loader-shield">
    <svg
      style="position: absolute; width: 0; height: 0; overflow: hidden"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="shieldLoader">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.3276 62.9849C24.3355 62.9859 24.3434 62.987 24.3512 62.9884C24.403 62.9973 24.4397 63 24.4635 63L24.4884 62.9997C24.4915 62.9997 24.4946 62.9996 24.4978 62.9996C24.5024 62.9996 24.507 62.9996 24.5116 62.9997L24.5365 63C24.5603 63 24.597 62.9973 24.6488 62.9884L24.6609 62.9865L24.6724 62.9849C25.4858 62.8843 27.2487 62.3055 29.4987 61.1037C31.7333 59.91 34.4098 58.1222 37.0513 55.6417C42.3298 50.6847 47.4684 42.9629 48.6719 31.6699C48.6728 31.6617 48.6739 31.6535 48.6751 31.6454C48.8864 30.2995 48.9996 28.935 49 27.557L48.9562 25.838C48.956 25.8312 48.956 25.8245 48.9561 25.8178C49.0928 16.6949 48.8838 11.8033 48.6913 9.33554C48.597 8.1256 47.7731 7.14775 46.5919 6.75101L28.3017 0.607747C27.0689 0.193649 25.7854 -0.0086465 24.5035 0.000323502H24.4965C23.2146 -0.0086465 21.9311 0.193649 20.6983 0.607747L2.40813 6.75101C1.22695 7.14775 0.403031 8.1256 0.308666 9.33554C0.116198 11.8033 -0.092795 16.6949 0.043894 25.8177C0.043995 25.8245 0.043959 25.8312 0.043788 25.838L0 27.5569C0.000346 28.935 0.113575 30.2995 0.324857 31.6454C0.326137 31.6536 0.327215 31.6617 0.32809 31.67C1.53159 42.9629 6.67018 50.6847 11.9487 55.6417C14.5902 58.1222 17.2667 59.91 19.5013 61.1037C21.7513 62.3055 23.5142 62.8843 24.3276 62.9849ZM24.3346 61.4141C24.3422 61.4151 24.3498 61.4161 24.3573 61.4175C24.407 61.426 24.4422 61.4286 24.465 61.4286L24.4889 61.4283C24.4963 61.4281 24.5037 61.4281 24.5111 61.4283L24.535 61.4286C24.5578 61.4286 24.593 61.426 24.6427 61.4175L24.6543 61.4157L24.6654 61.4141C25.4456 61.3176 27.1365 60.7625 29.2947 59.6097C31.4381 58.4647 34.0053 56.7499 36.539 54.3707C41.6021 49.616 46.5309 42.2094 47.6853 31.3773C47.6862 31.3694 47.6872 31.3616 47.6884 31.3538C47.891 30.0628 47.9996 28.754 48 27.4323L47.958 25.7834C47.9578 25.7769 47.9578 25.7705 47.9579 25.7641C48.089 17.0135 47.8885 12.3216 47.7039 9.9545C47.6134 8.79394 46.8232 7.856 45.6902 7.47546L28.1465 1.58294C26.964 1.18575 25.7329 0.991708 24.5034 1.00031H24.4966C23.2671 0.991708 22.036 1.18575 20.8535 1.58294L3.30984 7.47546C2.17687 7.856 1.38658 8.79394 1.29607 9.9545C1.11146 12.3216 0.910993 17.0135 1.0421 25.764C1.0422 25.7705 1.04216 25.7769 1.042 25.7834L1 27.4322C1.00033 28.754 1.10894 30.0628 1.3116 31.3538C1.31283 31.3617 1.31386 31.3694 1.3147 31.3774C2.46908 42.2094 7.39793 49.616 12.461 54.3707C14.9947 56.7499 17.5619 58.4647 19.7053 59.6097C21.8635 60.7625 23.5544 61.3176 24.3346 61.4141Z"
            fill="#FF22EF"
          />
        </clipPath>
      </defs>
    </svg>

    <div class="loader-shield__block">
      <div class="loader-shield__inner"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loader-shield {
  flex-grow: 1;
  background-color: $color-dark-blue-100;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  &__block {
    width: 50px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    clip-path: url('#shieldLoader');
    backface-visibility: hidden;
  }

  &__inner {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    background: conic-gradient(#fff, #48a987);
    animation: rotate 2s linear forwards infinite;
  }
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
